import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { PublicOpenDataActionsEnum } from '../enums/PublicOpenDataActionsEnum';
import { IOpenDataState } from '../interfaces/IOpenDataState';
import { OpenDataAction } from '../types/OpenDataAction';

export function publicOpenDataReducer(state = {}, action: OpenDataAction): IOpenDataState {
  switch (action.type) {
    case PublicOpenDataActionsEnum.PUBLIC_OPEN_DATA_SET_DATA: {
      const { fetchedData } = action.payload;
      return {
        ...state,
        fetchedData,
      };
    }
    case PublicOpenDataActionsEnum.PUBLIC_OPEN_DATA_SET_ACTIVE_TAB: {
      const { activeTab } = action.payload;
      return {
        ...state,
        activeTab,
      };
    }
    case PublicOpenDataActionsEnum.PUBLIC_OPEN_DATA_SET_CHECKS_DATA: {
      const { checksData } = action.payload;
      return {
        ...state,
        checksData,
      };
    }
    default:
      return state;
  }
}

export const getPublicOpenDataFetchedData = (state: IRootState) => state.publicOpenData.fetchedData;
export const getPublicOpenDataActiveTab = (state: IRootState) => state.publicOpenData.activeTab;
export const getPublicOpenDataChecksData = (state: IRootState) => state.publicOpenData.checksData;
